import { render, staticRenderFns } from "./moneybird.vue?vue&type=template&id=dff4dcea&scoped=true&"
import script from "./moneybird.vue?vue&type=script&lang=js&"
export * from "./moneybird.vue?vue&type=script&lang=js&"
import style0 from "./moneybird.vue?vue&type=style&index=0&id=dff4dcea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dff4dcea",
  null
  
)

export default component.exports